/* eslint-disable yola/react/require-default-props */
import React, { forwardRef } from 'react';
import BaseSelect from '../base-select';
import { APPEARANCES, SIZES } from '../base-select/constants';
import LoadingIndicator from './loading-indicator';
const defaultOptions = [];

const SearchableSelect = forwardRef(
  (
    {
      size = SIZES.small,
      id = undefined,
      name = undefined,
      placeholder = '',
      noResultsText = '',
      options = defaultOptions,
      defaultValue = null,
      value,
      clearable = false,
      disabled = false,
      invalid = false,
      preventOverflow = false,
      onChange = Function.prototype,
      onBlur = Function.prototype,
      onFocus = Function.prototype,
      onInputChange = Function.prototype,
      openMenuOnFocus = false,
      filterOptionsFunction = undefined,
      asyncConfig = null,
      menuPlacement = 'auto',
      maxMenuHeight = undefined,
      components = undefined,
    },
    ref
  ) => {
    const defaultComponents = asyncConfig ? { LoadingIndicator } : undefined;
    const searchableComponents = components || defaultComponents;

    return (
      <BaseSelect
        ref={ref}
        appearance={APPEARANCES.searchable}
        size={size}
        asyncConfig={asyncConfig}
        withDropdownIndicator
        components={searchableComponents}
        id={id}
        name={name}
        placeholder={placeholder}
        noResultsText={noResultsText}
        options={options}
        defaultValue={defaultValue}
        value={value}
        clearable={clearable}
        disabled={disabled}
        invalid={invalid}
        preventOverflow={preventOverflow}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        onInputChange={onInputChange}
        openMenuOnFocus={openMenuOnFocus}
        filterOptionsFunction={filterOptionsFunction}
        menuPlacement={menuPlacement}
        maxMenuHeight={maxMenuHeight}
      />
    );
  }
);

SearchableSelect.displayName = 'SearchableSelect';

export default SearchableSelect;
